import { IScreen } from './iScreen';

class CreditScreen implements IScreen{

    constructor(){
        
    }

    setup(){
        
    }

    windowResized(): void {
        
    }

    draw(){
        buffer.background(0);

        buffer.textAlign(buffer.CENTER, buffer.CENTER);
        buffer.fill(255);
        buffer.textSize(35);
        buffer.noStroke();
        buffer.text("Credits", 0, -100);
        buffer.textSize(15);

        let txt = 
        "Developed by PiTi\n" +
        "Coding AI used\n" +
        "Varius open license assests used\n" +
        "Main characted made by Tosca and modified by PiTi"
        buffer.text(txt, 0, 0);

        buffer.textSize(24);
        buffer.fill(205 + (p5js.sin(p5js.frameCount / 5.0) * 25), 0, 0);
        buffer.text("> Return <", 0, 100);
    }

    keyPressed(){
        if(p5js.keyCode === p5js.ESCAPE || p5js.keyCode == p5js.ENTER || p5js.key == ' '){
            currentScreen = "mainMenu";
            iScreen = screens[currentScreen];
            //iScreen = new MainMenuScreen(p5js);
            return;
        }
    }

    keyReleased(){
        
    }

    returnToMenu(){
        currentScreen = "mainMenu";
        iScreen = screens[currentScreen];
    }

    mousePressed(){
        this.returnToMenu();
    }

    mouseReleased(){

    }

    touchStarted(){
        this.returnToMenu();
    }

    touchEnded(){
        
    }

    touchMoved(): void {
        
    }

    mouseWheel(event: any): void {
        
    }

}

export default CreditScreen;